import React, { useState, useMemo } from "react";
import {
  FormLayout,
  TextField,
  Autocomplete,
  Tooltip,
  Icon,
  Tag,
  Toast,
} from "@shopify/polaris";
import { QuestionMarkMinor, CirclePlusMajor } from "@shopify/polaris-icons";
import intl from "../../../../../../i18n/intl";
// * 自定义组件
import PlaceholderImage from "../../../../../../components/PlaceholderImage";
import _ from "lodash";
// * css
import "../../../index.css";
import { reqGetOptimizeProductTitle } from "../../../../../../api";
import { store } from "../../../../../../store";
import { changeBannerData } from "../../../../../../slice";

/**
 *
 * @param {Object} data 商品详情
 * @param {Function} setRuleForm 修改商品详情方法
 * @param {onSave} onSave 保存
 * @returns
 */
const Product = ({ data, setRuleForm, onSave, setChatData, chatData }) => {
  const [collectionValue, setCollectionValue] = useState(""); // Collections 输入值
  const [tagsValue, setTagsValue] = useState(""); // Tags 输入值
  const [productTypeValue, setProductTypeValue] = useState(""); // Product type 输入值

  // Collections 下拉列表数据
  const collectionsList = useMemo(() => {
    if (collectionValue) {
      return data?.Collections.filter((item) => {
        return (
          item.label.toLowerCase().indexOf(collectionValue.toLowerCase()) > -1
        );
      });
    }
    return data?.Collections;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionValue, data?.Collections]);

  // Tags 下拉列表数据
  const tagsList = useMemo(() => {
    if (tagsValue) {
      return data?.Tags.filter((item) => {
        return item.label.toLowerCase().indexOf(tagsValue.toLowerCase()) > -1;
      });
    }
    return data?.Tags;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagsValue, data?.Tags]);

  // ProductType 下拉列表数据
  const productTypeList = useMemo(() => {
    if (productTypeValue) {
      return data.ProductType.filter((item) => {
        return (
          item.label.toLowerCase().indexOf(productTypeValue.toLowerCase()) > -1
        );
      });
    }
    return data?.ProductType;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypeValue, data?.ProductType]);

  // 删除 Collection
  const removeCollection = async (item) => {
    const selected = _.filter(data?.SelectCollections, (id) => {
      return id !== item.value;
    });
    await handleChange({ SelectCollections: selected });
    onSave("collection");
  };
  const [flagTags,setFlagTags] = useState(false)
  // 添加 tag
  const addTag = async () => {
    const tagsList = [...data.Tags];
    const selectTags = [...data.SelectTags];
    if (flagTags) {
      return
    }
    tagsList.push({
      label: tagsValue,
      value: tagsValue,
    });
    selectTags.push(tagsValue);
    await handleChange({ Tags: tagsList, SelectTags: selectTags });
    onSave("tags");
    setTagsValue("");
  };
  // 删除 Tag
  const removeTag = async (item) => {
    const selected = _.filter(data.SelectTags, (id) => {
      return id !== item.value;
    });
    await handleChange({ SelectTags: selected });
    onSave("tags");
  };

  const [flagType,setFlagType] = useState(false)
  // 添加 Product type
  const addProductType = async () => {
    if (flagType) {
      return
    }
    const productTypeList = [...data.ProductType];
    productTypeList.push({
      label: productTypeValue,
      value: productTypeValue,
    });
    await handleChange({
      ProductType: productTypeList,
      SelectProductType: [productTypeValue],
    });
    onSave("productType");
    setProductTypeValue("");
  };

  // 删除 Product Type
  const removeProductType = async (item) => {
    const selected = _.filter(data.SelectProductType, (id) => {
      return id !== item.value;
    });
    await handleChange({ SelectProductType: selected });
    onSave("productType");
  };

  /**
   * 修改商品详情
   * @param {Object} 需要修改的字段名和字段值，可能会有多个字段
   */
  const handleChange = (objs) => {
    setRuleForm((preState) => {
      let currentData = preState.Product;
      let param = { ...currentData, ...objs };
      const params = { ...preState, Product: param };
      return params;
    });
  };

  // ai优化产品标题
  const [chatLoading, setChatLoading] = useState(false);
  const handleChatTitle = async (val, id) => {
    try {
      let params = {
        title: val,
      };
      if (chatData.chatAction) {
        // toggleToast2("Prior task in progress,please wait.");
        // setShowToast2(true);
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:intl.get('Prior task in progress,please wait.')
        }}));
        return;
      }
      setChatLoading(true);
      setChatData((prevValue) => ({
        ...prevValue,
        titleModal: true,
        chatAction: true,
      }));
      let res = await reqGetOptimizeProductTitle(params);
      if (res.code === "200") {
        setChatData((prevValue) => ({
          ...prevValue,
          chatAction: false,
          user_product_id: id,
          titleOpen: true,
          titleFc: handleChange,
          oldTitle: val,
          title: res.data.optimized_title,
        }));
        toggleToast(intl.get('Optimization completed'))
      } else {
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:res.msg
        }}));
        // toggleToast(res.msg, true);
      }
      setShowToast2(false);
      setChatLoading(false);
    } catch (error) {}
  };
  const handleCancel = () => {
    setChatData((prevValue) => ({
      ...prevValue,
      titleOpen: false,
      titleModal: false,
      chatAction: false,
    }));
    setShowToastText("");
    setShowToast(false);
    setShowToast2(false);
    setChatLoading(false);
  };

  const [showToast, setShowToast] = useState(false);
  const [showToast2, setShowToast2] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(!showToast);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toggleToast2 = (showToastText, showToastIserror = false) => {
    setShowToast(false);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toastMarkup =
    showToast && chatData.titleModal && showToastText !== "" ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast("")}
        error={showToastIserror}
        duration={1500}
      />
    ) : null;
  const toastMarkup2 =
    showToast2 && showToastText !== "" ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast2("")}
        error={showToastIserror}
        duration={1500}
      />
    ) : null;
  return (
    <div className="product-info">
      <div className="product-info-image">
        <PlaceholderImage src={data?.ImageUrl} alt="" />
        {/* {!data?.plat ? (
          <div className="aliexpress">
            <img src="/aliexpress.png" alt="aliexpress" width={30} />
            <span>{intl.get("Import from AliExpress")}</span>
          </div>
        ) : null} */}
        {data?.product_source_from === 1 && (
          <div className="aliexpress">
            <img src="/aliexpress.png" alt="aliexpress" width={30} />
            <span>{intl.get("Import from AliExpress")}</span>
          </div>
        )}
        {data?.product_source_from === 4 && (
          <div className="aliexpress">
            <img src="/temu/temu_icon.png" alt="Temu" width={30} />
            <span>{intl.get("Import from TEMU")}</span>
          </div>
        )}
      </div>
      <div className="product-info-detail">
        <FormLayout>
          <div>
            <span>{intl.get("Original title")}: </span>
            {(data?.product_source_from === 1 || data?.product_source_from === 4 ) ? (
              <a
                target="_blank"
                href={data?.OriginalUrl ? data?.OriginalUrl : "#"}
                className="ml-6 ml-al-6"
                rel="noopener noreferrer"
              >
                {data?.OriginalTitle}
              </a>
            ) : (
              <span className="ml-6">{data?.OriginalTitle}</span>
            )}
          </div>
          <div>
            {!data?.status && (
              <div className="chat_gpt_title">
                <span className="title">{intl.get("Title")}</span>
                {!chatLoading ? (
                  <div
                    className="chat_gpt_button_list"
                    onClick={() => handleChatTitle(data?.Title, data?.id)}
                  >
                    <div className="chat_gpt_button_list_img">
                      <img
                        width={20}
                        src="/chatgpt_base.png"
                        alt="dropshipman"
                      />
                    </div>
                    <div style={{ margin: "0 5px" }}>
                      {" "}
                      {intl.get("AI Title Optimization")}
                    </div>
                  </div>
                ) : (
                  <div
                    className="chat_gpt_button_list"
                    onClick={() => handleCancel()}
                  >
                    <div className="chat_gpt_button_list_img chat_gpt_button_list_imgs">
                      <img
                        width={20}
                        src="/chatgpt_loading.png"
                        alt="dropshipman"
                      />
                    </div>
                    <div style={{ margin: "0 5px" }}>
                      <Tooltip content="Stop optimization.">
                        <span> {intl.get("Optimizing...")}</span>
                      </Tooltip>
                    </div>
                    <img width={20} src="/chatgpt_stop.png" alt="dropshipman" />
                  </div>
                )}
              </div>
            )}
            <TextField
              // label="Title"
              value={data?.Title}
              disabled={data?.status || data?.isOverrideTitleAndDesc}
              maxLength={255}
              showCharacterCount
              onChange={(value) => {
                handleChange({ Title: value });
              }}
              onBlur={() => {
                onSave("title");
              }}
              autoComplete="off"
            />
          </div>
          {/* collections */}
          <div>
            <Autocomplete
              listTitle={intl.get("Collections")}
              allowMultiple
              options={collectionsList}
              selected={data?.SelectCollections}
              onSelect={async (options) => {
                await handleChange({ SelectCollections: options });
                onSave("collection");
              }}
              textField={
                <Autocomplete.TextField
                  value={collectionValue}
                  placeholder={intl.get("Search Collections")}
                  helpText={intl.get("Assign products to manual collections.")}
                  disabled={data?.status}
                  onChange={(value) => {
                    setCollectionValue(value);
                  }}
                  label={
                    <div className="collection-label">
                      <span>{intl.get("Collections")}</span>
                      <div style={{ width: "1.6rem" }}>
                        <Tooltip
                          content={intl.get(
                            "If you need to add a new collection, please go to shopify store> products > collections > create collections to create a new manual collection and refresh this page."
                          )}
                        >
                          <Icon source={QuestionMarkMinor} backdrop={true} />
                        </Tooltip>
                      </div>
                    </div>
                  }
                />
              }
              emptyState={
                <div style={{ textAlign: "left", marginLeft: "16px" }}>
                   
                    {intl.get("there is no collections to select.")}
                   
                </div>
              }
            />
            <div className="mt-2">
              {_.map(data?.Collections, (item) => {
                if (_.includes(data?.SelectCollections, item.value)) {
                  return (
                    <div key={item.value} className="inline-block mr-3">
                      <Tag
                        onRemove={() => {
                          removeCollection(item);
                          setCollectionValue("");
                        }}
                        disabled={data?.status}
                      >
                        {item.label}
                      </Tag>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </div>

          <FormLayout.Group>
            {/* Tags */}
            <div>
              <Autocomplete
                listTitle={intl.get("Suggested Tags")}
                allowMultiple
                options={tagsList}
                selected={data?.SelectTags}
                onSelect={async (options) => {
                  await handleChange({ SelectTags: options });
                  onSave("tags");
                }}
                textField={
                  <Autocomplete.TextField
                    onChange={(value) => {
                      setTagsValue(value.trim());
                      const tagsList = [...data.Tags];
                      let flag = false;
                      for (let i = 0; i < tagsList.length; i++) {
                        if (tagsList[i].value === value) {
                          flag = true
                        }
                      }
                      if (flag) {
                        setFlagTags(true)
                      }else {
                        setFlagTags(false)
                      }
                    }}
                    label={intl.get("Tags")}
                    value={tagsValue}
                    // onBlur={()=>this.addNewFieldElement('tags','')}
                    placeholder={intl.get("Search tags, comma to split")}
                    disabled={data?.status}
                  />
                }
                actionBefore={(tagsValue && !flagTags) && {
                  accessibilityLabel: '',
                  badge: {
                    tone: 'new',
                    content: 'New!',
                  },
                  content: intl.get("Add") + ' ' + tagsValue,
                  // ellipsis: true,
                  helpText: '',
                  icon: CirclePlusMajor,
                  wrapOverflow: true,
                  onAction: () => addTag(),
                }}
                // emptyState={
                //   tagsValue ? (
                //     <div
                //       className="flex cursor-pointer"
                //       style={{ marginLeft: "16px",zIndex:105 }}
                //       onClick={()=>addTag()}
                //     >
                //       <div className="Product__Add_tag mr-2">
                //         <Icon source={CirclePlusMajor} color="interactive" />
                //       </div>
                //       <div className="Product__Add_tag" >
                //         <b>{intl.get("Add")}</b> &nbsp;{tagsValue}
                //       </div>
                //     </div>
                //   ) : (
                //     tagsList &&
                //     tagsList?.length === 0 &&
                //     intl.get("there is no tags to select.")
                //   )
                // }
              />
              <div className="mt-2">
                {_.map(data?.Tags, (item) => {
                  if (_.includes(data?.SelectTags, item.value)) {
                    return (
                      <div key={item.value} className="inline-block mr-3 mb-2">
                        <Tag
                          onRemove={() => {
                            removeTag(item);
                            setTagsValue("");
                          }}
                          disabled={data?.status}
                        >
                          {item.label}
                        </Tag>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </div>

            {/* Product type */}
            <div>
              <Autocomplete
                options={productTypeList}
                selected={data?.SelectProductType}
                onSelect={async (options) => {
                  await handleChange({ SelectProductType: options });
                  onSave("productType");
                }}
                textField={
                  <Autocomplete.TextField
                    onChange={(value) => {
                      setProductTypeValue(value);
                      const productTypeList = [...data.ProductType];
                      let flag = false;
                      for (let i = 0; i < productTypeList.length; i++) {
                        if (productTypeList[i].value === value) {
                          flag = true
                        }
                      }
                      if (flag) {
                        setFlagType(true)
                      }else {
                        setFlagType(false)
                      }
                    }}
                    label={intl.get("Product type")}
                    value={productTypeValue}
                    placeholder={intl.get("Search product type")}
                    disabled={data?.status}
                  />
                }
                actionBefore={(productTypeValue && !flagType) && {
                  accessibilityLabel: '',
                  badge: {
                    tone: 'new',
                    content: 'New!',
                  },
                  content: intl.get("Add") + ' ' + productTypeValue,
                  // ellipsis: true,
                  helpText: '',
                  icon: CirclePlusMajor,
                  wrapOverflow: true,
                  onAction: () => addProductType(),
                }}
                // emptyState={
                //   productTypeValue ? (
                //     <div
                //       className="flex cursor-pointer"
                //       onClick={addProductType}
                //       style={{ marginLeft: "16px" }}
                //     >
                //       <div className="Product__Add_tag mr-2">
                //         <Icon source={CirclePlusMajor} color="interactive" />
                //       </div>
                //       <div className="Product__Add_tag">
                //         <b>{intl.get("Add")}</b> &nbsp;{productTypeValue}
                //       </div>
                //     </div>
                //   ) : (
                //     productTypeList &&
                //     productTypeList?.length === 0 &&
                //     intl.get("there is no type to select.")
                //   )
                // }
              />
              <div className="mt-2">
                {_.map(data?.ProductType, (item) => {
                  if (_.includes(data?.SelectProductType, item.value)) {
                    return (
                      <div key={item.value} className="inline-block mr-3">
                        <Tag
                          onRemove={() => {
                            removeProductType(item);
                            setProductTypeValue("");
                          }}
                          disabled={data?.status}
                        >
                          {item.label}
                        </Tag>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </div>
          </FormLayout.Group>
        </FormLayout>
      </div>
      {toastMarkup}
      {toastMarkup2}
    </div>
  );
};

export default Product;
